<template>
  <v-container>
    <v-row>
      <v-col>
        <p>Возвращает прогнозы для множества территорий. Ответ содержит массив data, который представляет собой список прогнозов для территорий. Территория area_id – идентификатор территории, forecast_message – тело прогноза.</p>

        <div class="text-subtitle-1">Заголовки запроса</div>
        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Заголовок</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример значения</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Authorization</td>
              <td>JWT токен доступа</td>
              <td>Bearer eyJhbGciOiJSUzI1NiIsImtp...</td>
            </tr>
            <tr>
              <td>Accept-Encoding</td>
              <td>
                Вы можете указать параметр gzip для сжатия ответа. Настоятельно рекомендуем использовать этот заголовок!
                Например, если без сжатия, ответ занимает 4 мегабайта, то с gzip сжатием он будет занимать около 150 килобайт.
              </td>
              <td>gzip</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Типы запросов</div>

        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Пример</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <code>curl -d '["6000423e8e049919e854af19","6000423e8e049919e854af12"]' -H "Content-Type: application/json" -H 'Authorization: Bearer eyJhbGciOiJSUzI1NiIsImtp...' -X POST {{ $settings.VUE_APP_GATEWAY_SERVICE_ENDPOINT }}/api/1.2/forecast/presets</code>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Ответ</div>

        <v-simple-table class="table">
          <thead>
            <tr>
              <td>
                <b>Пример ответа</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <json-viewer :value="response" copyable boxed sort></json-viewer>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <div class="text-subtitle-1">Общие сведения</div>
          <p>Получить список активных территорий можно с помощью API.</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: function() {
    return {
      response: {
        status_code: 200,
        result: {
          data: [
            {
              area_id: "6000423e8e049919e854af16",
              forecast_message: {
                points: [
                  {
                    x: 40.385668955824464,
                    y: 46.96264549110353
                  },
                  {
                    x: 40.385668955824464,
                    y: 46.94597879110353
                  },
                  {
                    x: 40.385668955824464,
                    y: 46.929312091103526
                  }
                ],
                parameters: [
                  {
                    level_type: "surface",
                    level: 0,
                    pname: "2 metre dewpoint temperature",
                    sname: "2d",
                    unit: "c"
                  },
                  {
                    level_type: "surface",
                    level: 0,
                    pname: "2 metre temperature",
                    sname: "2t",
                    unit: "c"
                  }
                ],
                ref_time: "2021-12-25T00:00:00Z",
                predicts: [60, 120, 180, 240],
                values: [
                  -9.342007090426012,
                  -8.750049884363474,
                  -8.159942422098027,
                  -9.342007090426012,
                  -8.750049884363474,
                  -8.159942422098027
                ]
              }
            },
            {
              area_id: "6000423e8e049919e854af19",
              forecast_message: {
                points: [
                  {
                    x: 40.385668955824464,
                    y: 46.96264549110353
                  },
                  {
                    x: 40.385668955824464,
                    y: 46.94597879110353
                  },
                  {
                    x: 40.385668955824464,
                    y: 46.929312091103526
                  }
                ],
                parameters: [
                  {
                    level_type: "surface",
                    level: 0,
                    pname: "2 metre dewpoint temperature",
                    sname: "2d",
                    unit: "c"
                  },
                  {
                    level_type: "surface",
                    level: 0,
                    pname: "2 metre temperature",
                    sname: "2t",
                    unit: "c"
                  }
                ],
                ref_time: "2021-12-25T00:00:00Z",
                predicts: [60, 120, 180, 240],
                values: [
                  -9.342007090426012,
                  -8.750049884363474,
                  -8.159942422098027,
                  -9.342007090426012,
                  -8.750049884363474,
                  -8.159942422098027
                ]
              }
            },
            {
              area_id: "6001b3b925276485b6640090",
              forecast_message: {
                points: [
                  {
                    x: 57.159148306982416,
                    y: 34.82915993354493
                  },
                  {
                    x: 57.159148306982416,
                    y: 34.81249323354493
                  },
                  {
                    x: 57.159148306982416,
                    y: 34.795826533544925
                  }
                ],
                parameters: [
                  {
                    level_type: "surface",
                    level: 0,
                    pname: "2 metre dewpoint temperature",
                    sname: "2d",
                    unit: "c"
                  },
                  {
                    level_type: "surface",
                    level: 0,
                    pname: "2 metre temperature",
                    sname: "2t",
                    unit: "c"
                  }
                ],
                ref_time: "2021-12-25T00:00:00Z",
                predicts: [60, 120, 180, 240],
                values: [
                  -4.885655663381077,
                  -4.8830490905961925,
                  -4.884654279091892,
                  -4.8862594675875926,
                  -4.887864656083291,
                  -4.879377178977168
                ]
              }
            }
          ],
          count: 3
        }
      }
    };
  }
};
</script>